class OutfitViewerDrawer extends HTMLElement {
  constructor() {
    super();

    this.addAllToCartBtn = this.querySelector('.js-addAllToCart-btn');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.addAllToCartBtn.addEventListener('click',this.addAllToCartListener.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  getItemData(){

    let selectedVariants = Array.from(this.querySelectorAll('[name="id"]:not([disabled])')).map(ele => ele.value);
    let items = selectedVariants
    .map(id => {
      let allVariants = Array.from(this.querySelectorAll('.js-variant-id'));
      let selectedVariant = allVariants.find(item => item.value === id);
      if (selectedVariant) {
        let productMetaId = selectedVariant.closest('form').querySelector('.js-product-meta-id').value;
        let variantMetaId = selectedVariant.closest('form').querySelector('.js-variant-meta-id').value;
        let productFinalPrice = selectedVariant.closest('form').querySelector('.js-product-final-price').value;
        let productSale = selectedVariant.closest('form').querySelector('.js-product-sale').value;
        let vendorName = selectedVariant.closest('form').querySelector('.js-product-vendor-name').value;

        let props = {
          _bid: productMetaId,
          _pid: variantMetaId,
          _finalSale: productFinalPrice,
          _sale: productSale,
          _vendorName: vendorName
        }

        if(props._finalSale == 'Yes') {
          props['_LPROP'] = 'final-sale';
        }

        return {
          id,
          quantity: 1,
          properties: props,
          wrapper: selectedVariant.closest('.poruduct_item')
        };
      }
    }).filter(item => item !== undefined); 

    // this.addAllToCartBtn.disabled = (selectedVariants.length == 0);
    // this.addAllToCartBtn.classList.toggle('disabled',selectedVariants.length == 0);

    let flag = false;
    let outfitGroup = document.querySelectorAll('outfit-viewer-drawer');
      if(outfitGroup){
        outfitGroup.forEach((group) => {
          if(group.classList.contains('active')){
            items.forEach((item, index) => {
              if(item.id != ""){
                let errorContainer = document.querySelector(`.js-outfit-product-item-${index+1} .js-outfit-error-message`);
                if(errorContainer){
                  errorContainer.remove();
                }
              }
              else if(item.id == ""){
                flag = true
              }
            });
          }
        })
      }
    // if(!flag && !this.querySelector('.js-above-add-btn-error').classList.contains('hidden')) this.querySelector('.js-above-add-btn-error').classList.add('hidden');

    return {
      items
    }
  }

  async addAllToCartListener(event){

      this.addAllToCartBtn.setAttribute('aria-disabled', true);
      this.addAllToCartBtn.classList.add('loading');
      this.addAllToCartBtn.querySelector('.loading__spinner').classList.remove('hidden');

      let drawerData = this.getItemData();
      let flag = false;
      let scrollFlag = true;
      let outfitGroup = document.querySelectorAll('outfit-viewer-drawer');
      if(outfitGroup){
        outfitGroup.forEach((group) => {
          if(group.classList.contains('active')){
            drawerData.items.forEach((item, index) => {
              let outfitProduct = item.wrapper;
              let errorContainer = outfitProduct.querySelector(`.js-outfit-error-message`);
              if(errorContainer){
                errorContainer.remove();
              }
              if (item.id == "") {
                let errorDiv = document.createElement('div');
                errorDiv.className = 'js-outfit-error-message';
                errorDiv.textContent = 'Please select a size';
                errorDiv.style.color = 'red';
                outfitProduct.appendChild(errorDiv);
                flag = true;
                // this.querySelector('.js-above-add-btn-error').classList.remove('hidden');
              }
              if(item.id == "" && scrollFlag){
                group.querySelector('.js-outfit-content').scrollTo({
                  top: outfitProduct.offsetTop - document.querySelector('.js-drawer-header').offsetHeight - 16,
                  behavior: "smooth"
                });
                scrollFlag = false;
              }
            });
          }
        })
      }
      if(flag){
        this.addAllToCartBtn.removeAttribute('aria-disabled');
        this.addAllToCartBtn.classList.remove('loading');
        this.addAllToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
        return;
      }

      let cartData = await fetch(window.Shopify.routes.root + 'cart.js');
      let cartDataJson = await cartData.json();
      let cartVariantIds = cartDataJson.items.map(item => item.variant_id);

      let cartProductVariants = cartVariantIds;

      drawerData.items = drawerData.items.filter(item => !cartProductVariants.includes(parseInt(item.id))).map(item => {
        return {
          id:item.id,
          properties: item.properties,
          quantity: item.quantity
        }
      });

      if(drawerData.items.length == 0){
        this.addAllToCartBtn.removeAttribute('aria-disabled');
        this.addAllToCartBtn.classList.remove('loading');
        this.addAllToCartBtn.querySelector('.loading__spinner').classList.add('hidden');

        let alertMsg = `<span class="js-all-product-alert" style="color: red;">All products are already added in a cart..</span>`;
        this.addAllToCartBtn.insertAdjacentHTML('beforebegin',alertMsg);
        setTimeout(() => {
          document.querySelector('.js-all-product-alert').remove();
        },5000)
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';

      let formData = {};
      formData.items = drawerData.items;
      formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {

        this.close();
        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {      
        this.addAllToCartBtn.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.addAllToCartBtn.removeAttribute('aria-disabled');
        this.addAllToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
      });
  }

  reset(){
    this.querySelectorAll('variant-selects').forEach(element => {
      element.querySelector('.select__select').value = "";
    });
    this.querySelectorAll('[name="id"]').forEach(ele => ele.value = "");
    this.getItemData();
  }

  open(triggeredBy) {
    document.body.classList.add('overflow-hidden');
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        // trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

  }

  close() {
    this.classList.remove('active');
    // removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('outfit-viewer-drawer', OutfitViewerDrawer);


class SectionOutfit extends HTMLElement{
  constructor(){
    super();
    this.OutfitViewerDrawer = this.querySelector('outfit-viewer-drawer');
    this.outfit_slider = document.querySelector('.outfit_slider');
    this.querySelector('.js-add-all-to-cart').addEventListener('click',() => {
      if(this.outfit_slider){
        let drawer = document.querySelector(`outfit-viewer-drawer#${this.flktyOutfitSlider.selectedElement.dataset.drawerId}`);
        drawer.open();
      }else{
        this.OutfitViewerDrawer.open();
      }
    });
    this.initSlider()
    this.checkSelectedItem();
  }
  initSlider(){
    if (this.outfit_slider) {
      let prevButton = this.querySelector('.button--previous');
      let nextButton = this.querySelector('.button--next');
      this.flktyOutfitSlider = new Flickity(this.outfit_slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        draggable: false,
        adaptiveHeight: true,
        on: {
          scroll: progress=>{
              let calc = Math.max(0, Math.min(1, progress));
              prevButton && (prevButton.disabled = calc == 0),
              nextButton && (nextButton.disabled = calc == 1)
          },
          change: () => this.checkSelectedItem()
        }
      });
      if (prevButton) {
        prevButton.addEventListener('click', () => this.flktyOutfitSlider.previous());
      }
      if (nextButton) {
        nextButton.addEventListener('click', () => this.flktyOutfitSlider.next());
      }
    }
  }

  checkSelectedItem() {
    let addAllToCart = this.querySelector('.js-add-all-to-cart');
    let shopLookBtn = document.querySelector('.js-shop-look-btn');
    if(addAllToCart){
      addAllToCart.classList.remove('hidden');
      if(shopLookBtn) shopLookBtn.classList.remove('hidden');
    }
    if(addAllToCart && window.matchMedia("(max-width: 749px)").matches){
      //addAllToCart.classList.add('hidden');
    }
    let outfitItemCount = this.querySelectorAll('.js-outfit-item');
    if(outfitItemCount.length > 1){
      if(this.querySelector('.js-outfit-item.is-selected')){
        let selectedItem = this.querySelector('.js-outfit-item.is-selected').getAttribute('data-product-size');
        if (addAllToCart && selectedItem == 1) {
          addAllToCart.classList.add('hidden');
          if(shopLookBtn) shopLookBtn.classList.add('hidden');
        }
      }
    }
    else if(outfitItemCount.length == 1){
      if(this.querySelector('.js-outfit-item')){
        let selectedItem = this.querySelector('.js-outfit-item').getAttribute('data-product-size');
        if (addAllToCart && selectedItem == 1) {
          addAllToCart.classList.add('hidden');
          if(shopLookBtn) shopLookBtn.classList.add('hidden');
        }
      }
    }
  }

}
customElements.define('section-outfit', SectionOutfit);
